import React, { useEffect, useState } from "react";
import { DELETE } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import Alert from "@/components/alert/Alert";
import ChangesAlert from "@/components/alert/ChangesAlert";
import BartCard from "./BartCard";
import { BartenderInteface } from "@/interfaces/Bartender";

interface Bartender {
  editBusinessId:string;
    bartendersList: BartenderInteface[];
    editStateFun:(id:string,name:string)=> void;
  }
  

const BartList:React.FC<Bartender> = ({bartendersList,editStateFun,editBusinessId}) => {
  const { refreshToken } = useAppSelector((store) => store.user);
  const { bartenders } = API_ROUTES
  const [list, setList] = useState<any[]>([...bartendersList])
  const [modal, setModal] = useState<boolean>(false)
  const [activeId, setActiveId] = useState<string>("")

  const handleDelete = async () => {
    try {
      const response = await DELETE(`${bartenders}/${activeId}?businessId=${editBusinessId}`, refreshToken);
      setList(list.filter(item => item.id !== activeId))
      Alert({ message: response?.data?.message })
      setModal(false)
    } catch (error) {
      console.log(error);
      setModal(false)
    }
  }
  useEffect(()=>{
    setList(bartendersList)
  },[bartendersList])
//flex md:flex-row flex-col items-center lg:gap-5 justify-center flex-wrap
  return (
    <div className="flex md:justify-start justify-center   gap-3 flex-wrap ">
      {list.map((item: BartenderInteface, index: number) => (

            <BartCard key={index} setModal={setModal} setActiveId={setActiveId} bartender={item} index={index} editStateFun={editStateFun} />
      ))}
      <ChangesAlert
        title={"Delete Bartender"}
        desc={`Are you sure you want to delete this Bartender?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => { setModal(false) }}
        handleSaveChanges={handleDelete}
        isOpen={modal} />
    </div>
  );
};

export default BartList;
